module.exports = __webpack_public_path__ + "img/c87fbfd.jpg";